import { FilterType } from '@enums';
import { ChoiceFilter, DateFilter, MultiChoiceFilter, SingleChoiceFilter, ValueRangeFilter } from '@model';


export class FilterDefinition {
  name: string;
  filterId: string;
  filterType: FilterType;
  label: string;
  data: string[];
  selected: string[];  // Show as chip
  dateFilter: DateFilter;
  valueRangeFilter: ValueRangeFilter;
  multiChoiceFilter: MultiChoiceFilter;
  singleChoiceFilter: SingleChoiceFilter;
  checkBoxFilter: ChoiceFilter;
}
